// extracted by mini-css-extract-plugin
export default {"btn_pin":"ProfilePinModals_btn_pin__YYNoL","btn_pin_close":"ProfilePinModals_btn_pin_close__E+nqM"};